'use client';

import { useEffect, useRef } from 'react';

import type { PageSectionAnalyticsTrackingProps } from './types';

export function PageSectionAnalyticsTracking({
    sectionId,
    eventCallback,
    enabled = true,
    OnIntersect = () => null,
    children,
    className,
}: PageSectionAnalyticsTrackingProps) {
    const sectionRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!('IntersectionObserver' in window)) {
            return undefined;
        }

        const divElement = sectionRef.current;

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting && enabled) {
                    if (eventCallback) {
                        eventCallback();
                    }

                    observer.unobserve(entry.target);
                }

                if (entry.isIntersecting) {
                    OnIntersect();
                }
            });
        });

        if (divElement) {
            observer.observe(divElement);
        }

        return () => {
            if (divElement) {
                observer.unobserve(divElement);
            }
        };
    }, [eventCallback, sectionId]);

    return (
        <div ref={sectionRef} id={sectionId} className={className}>
            {children}
        </div>
    );
}
